import { useQuery } from '@tanstack/react-query';
import { WidgetSettingsDto } from '@/Domain/api/WIdget/dto/WidgetSetting.dto';
import { CenterSpinner } from '@/Domain/components/Shared/CenterSpinner/CenterSpinner';
import { AppearancePage } from '@/UI/Website/Appearance/Appearance.page';

export const AppearanceLoader = () => {
  const { data, isLoading } = useQuery({ queryKey: ['widget-settings'] });

  if (isLoading) {
    return <CenterSpinner />;
  }

  return <AppearancePage data={data! as WidgetSettingsDto} />;
};
